import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import Header from '../../components/Header';
import Sider from '../../components/Sider';
import AiTraining from '../../components/AiTraining';
import AiTrainingAdd from '../../components/AiTrainingAdd';

import {
  Section,
  Wrapper,
  Content,
  Panel,
  PanelInner,
  Box,
  Navigation,
  Button,
  Center,
  Information,
  Text,
} from './AiTrainingPage.style';

const AiTrainingPage = () => {
  const intl = useIntl();
  const theme = useTheme();
  const [visibleAiTrainingModal, setVisibleAiTrainingModal] = useState(false);
  const { profile } = useSelector((state) => state.firebase);
  const isProfileCompany = profile.company && profile.company.id ? true : false;

  const handleOpenAiTrainingAdd = () => setVisibleAiTrainingModal(true);

  const handleCloseAiTrainingAdd = () => setVisibleAiTrainingModal(false);

  const renderInformation = (information) => {
    return (
      <Center>
        <Information theme={theme.content.information.default}>
          <Text>{information}</Text>
        </Information>
      </Center>
    );
  };

  const renderPanelNavigation = () => {
    return (
      <Navigation>
        <Button
          theme={theme.button.default}
          onClick={() => handleOpenAiTrainingAdd()}
          small
        >
          {intl.formatMessage({
            id: `AI_TRAINING.NEW_NEURAL_NETWORK`,
          })}
        </Button>
      </Navigation>
    );
  };

  const renderPanelBox = () => {
    return (
      <Box>
        <AiTraining />
      </Box>
    );
  };

  return (
    <>
      <Helmet title={intl.formatMessage({ id: 'PAGE_TITLE.AI_TRAINING' })} />
      <Section>
        <Sider />
        <Wrapper>
          <Header
            title={intl.formatMessage({ id: 'PAGE_TITLE.AI_TRAINING' })}
          />
          <Content>
            <Panel theme={theme.content.panel.default}>
              <PanelInner>
                {!isProfileCompany ? (
                  renderInformation(
                    intl.formatMessage({
                      id: `AI_TRAINING.YOU_HAVE_NO_ASSIGNED_COMPANY`,
                    })
                  )
                ) : (
                  <>
                    {renderPanelNavigation()}
                    {renderPanelBox()}
                  </>
                )}
              </PanelInner>
            </Panel>
          </Content>
        </Wrapper>
      </Section>
      {visibleAiTrainingModal && (
        <AiTrainingAdd handleClose={() => handleCloseAiTrainingAdd()} />
      )}
    </>
  );
};

export default AiTrainingPage;
